<script lang="ts">
  import type { CheckoutSdk } from '@athena-lib/Checkout/utils';
  import ShipTo from '../Menu/ShipTo.svelte';
  import type { ShippingDetails } from './types';

  type ShippingBannerProps = {
    shippingDetails?: ShippingDetails;
    checkoutSdk: CheckoutSdk | null;
  };

  const { shippingDetails, checkoutSdk }: ShippingBannerProps = $props();
</script>

<div class="flex flex-row items-center justify-end gap-2 bg-st-black px-6 py-2 text-st-white">
  {#if checkoutSdk}
    <ShipTo
      type="shippingBanner"
      {checkoutSdk}
      onUpdateCountry={checkoutSdk.updateCountry}
      currentCountry={shippingDetails?.country}
    />
  {/if}
</div>
